import CallbotPaletteProvider from "./CallbotPaletteProvider";

export default {
  __init__: ['paletteProvider'],
  paletteProvider: ['type', CallbotPaletteProvider],
}
